import "../../App.css";

import React from 'react';
import HomeHeroSection from "../HomeHeroSection";
import {DetailPanel} from "../DetailPanel";

function Home() {
	return (
		<>
			<span id="home"/>
			<HomeHeroSection/>

			<div className="columns">

				<DetailPanel title={"Poradenství"} icon={"blur_linear"} id="poradenstvi">
					Jsme připraveni navrhovat řešení v oblasti Vašeho působení ať už se budou týkat SW nebo HW.
				</DetailPanel>

				<DetailPanel title={"Vyvoj"} icon={"developer_mode_sharp"} id="vyvoj">
					Zabýváme se vývojem SW na míru dle zadání zákazníka i implementací software třetích stran.
				</DetailPanel>

				<DetailPanel title={"Servis"} icon={"domain_sharp"} id="servis">
					Díky našim dlohodobým zkušenostem zajistíme kvalitní podporu a servis vaší infrastruktury.
				</DetailPanel>

				<DetailPanel title={"Prodej"} icon={"account_balance"} id="prodej">
					Zajistíme dodání, zapojení i servis IT vybavení (PC, síťových prvků apod.) s plnou zárukou a podporou.
				</DetailPanel>

			</div>

		</>
	);
}

export default Home;